import { View } from "extensions/marionette";
import { CollectionView } from "backbone.marionette";

import { SavedFilter } from "./savedFilter";
import savedFiltersListTemplate from "./savedFiltersList.jst";

const List = CollectionView.extend({
    className: "saved-filters",
    childView: SavedFilter,
    childViewTriggers: {
        action: "action"
    }
});

export const SavedFiltersList = View.extend({
    template: savedFiltersListTemplate,
    className: "saved-fitlers-box",
    regions: {
        list: {
            replaceElement: true,
            el: ".saved-filters"
        }
    },
    
    childViewTriggers: {
        action: "action"
    },
    
    onRender() {
        this.showChildView("list", new List({
            collection: this.collection
        }));
    }
});
